// Даты — строки 'yyyy-MM-dd', время дня — 'HH:mm' или минуты от полуночи (600 = 10:00).
// Дни недели: 0 = понедельник … 6 = воскресенье. Всё считается в UTC, поэтому часовой пояс машины не влияет.

export function pad2(n: number): string {
  return (n < 10 ? '0' : '') + n;
}

export function hmToMin(s: string | null | undefined): number | null {
  const m = String(s ?? '').match(/^\s*(\d{1,2})[:.](\d{2})/);
  return m ? Number(m[1]) * 60 + Number(m[2]) : null;
}

export function minToHm(min: number): string {
  const m = Math.round(min);
  return pad2(Math.floor(m / 60)) + ':' + pad2(m % 60);
}

function ymd(s: string): [number, number, number] {
  const [y = 0, m = 1, d = 1] = s.split('-').map(Number);
  return [y, m, d];
}

function isoOfUtc(d: Date): string {
  return d.getUTCFullYear() + '-' + pad2(d.getUTCMonth() + 1) + '-' + pad2(d.getUTCDate());
}

export function isDateStr(s: unknown): s is string {
  return /^\d{4}-\d{2}-\d{2}$/.test(String(s));
}

export function addDays(s: string, n: number): string {
  const [y, m, d] = ymd(s);
  return isoOfUtc(new Date(Date.UTC(y, m - 1, d + n)));
}

export function dowOf(s: string): number {
  const [y, m, d] = ymd(s);
  return (new Date(Date.UTC(y, m - 1, d)).getUTCDay() + 6) % 7;
}

export function weekStartOf(s: string): string {
  return addDays(s, -dowOf(s));
}

export function monthOf(s: string): string {
  return s.slice(0, 7);
}

export function daysInMonth(ym: string): number {
  const [y, m] = ymd(ym);
  return new Date(Date.UTC(y, m, 0)).getUTCDate();
}

export function addMonths(ym: string, n: number): string {
  const [y, m] = ymd(ym);
  const d = new Date(Date.UTC(y, m - 1 + n, 1));
  return d.getUTCFullYear() + '-' + pad2(d.getUTCMonth() + 1);
}

// То же число через n месяцев; если такого числа нет (31-е) — последний день месяца.
export function addMonthsDate(iso: string, n: number): string {
  const [y, m, d] = ymd(iso);
  const ym = addMonths(y + '-' + pad2(m), n);
  return ym + '-' + pad2(Math.min(d, daysInMonth(ym)));
}

// Номер дня от 1970-01-01 — чтобы считать разницу между датами.
export function dayNum(s: string): number {
  const [y, m, d] = ymd(s);
  return Date.UTC(y, m - 1, d) / 86400000;
}
